import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (!SENTRY_DSN || isLocal) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
      // Onboarding collects medical conditions, medications, injuries and body
      // metrics, and `setSentryUser` below attaches an email to the session.
      // Masking has to stay on: a replay is otherwise a copy of someone's
      // health record leaving the platform. Where they clicked and which step
      // they abandoned survives masking, which is all these recordings are for.
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function setSentryUser(user) {
  if (!SENTRY_DSN) return;

  if (user) {
    Sentry.setUser({ id: user._id, email: user.email, username: user.name });
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };
